import { useContext } from "react";
import { TermsModalContext, type TermsModalContextValue } from "./termsModalContextValue";

export function usePlatformTermsModal(): TermsModalContextValue {
  const ctx = useContext(TermsModalContext);
  if (!ctx) {
    throw new Error("usePlatformTermsModal must be used within TermsModalProvider");
  }
  return ctx;
}
